import useImageZoom from "../../../../framework/connectors/image-tools/useImageZoom";
import ImageZoom from "./ImageZoom";
import React, { useEffect } from "react";

export default function ImageZoomFromPage() {
  const { eventData, refocus, clear } = useImageZoom();

  useEffect(() => {
    if (!eventData) {
      refocus();
    }
  }, [refocus, eventData]);

  return (
    <ImageZoom
      src={eventData?.imageURL}
      open={!!eventData}
      onRequestClose={clear}
      description={eventData?.caption}
    />
  );
}
